// Module
var code = "<div><h2>Shop Quality Partners</h2></div>";
// Exports
module.exports = code;